// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import VueMaterial from 'vue-material'

import store from './PriceCheckStore'

import VueI18n from 'vue-i18n'

//import './assets/screen-min.css'

Vue.config.productionTip = false
Vue.use(VueMaterial)

Vue.use(VueI18n)

const i18n = new VueI18n({
    locale: 'en',
    messages: {
	'en': {
	    'evaluation': 'evaluation mode'
	},
	'ja': {
	    'evaluation': '評価用サイト'
	}
    }
})

/* eslint-disable no-new */
new Vue({
  el: '#main',
  router,
  store,
  i18n,
  template: '<App />',
  /* computed: {
      path: function() {
	  return document.getElementById('body').getAttribute('ctxPath')
      }
  }, 
  beforeMount() {
      console.log(document.getElementById('body').getAttribute("ctxPath"))
  }, */
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js